import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n    display: inline-block;\n    background-color: rgba(255, 255, 255, 0.8);\n    height: 1.4em;\n    width: 0.5em;\n    vertical-align: middle;\n    margin-left: 0.2em;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    color: #abc123;\n    padding-right: 0.5em;\n    font-weight: bold;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    background-color: rgba(255, 255, 255, 0.05);\n    padding: 0.2em 0.3em;\n    border-radius: 0.2em;\n    margin-top: 1em;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    white-space: nowrap;\n    line-height: 1.4em;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import styled from 'styled-components';
import { useElementSize } from '../../hooks/useElementSize';
import { useStep } from '../../hooks/useStep';
import { trail, fromTo, val, text, sequence, delay } from 'light-trails';
export const Cmd = props => {
  const ref = useRef(null);
  const textRef = useRef(null);
  const cursorRef = useRef(null);
  const size = useElementSize(ref);
  useStep(props.in, ({
    duration
  }) => sequence([trail(ref.current, [fromTo({
    height: val(0, size.height, 'px')
  }, duration.normal)]), trail(textRef.current, [delay(duration.normal), fromTo({
    text: text(props.name)
  }, duration.normal)]), trail(cursorRef.current, [fromTo({
    opacity: val(1, 0)
  }, duration.fast)])]), {
    title: 'Cmd',
    deps: [size !== null]
  });
  return React.createElement(Container, {
    ref: ref
  }, React.createElement(Line, null, React.createElement(Prompt, null, "\u279C"), React.createElement("span", {
    ref: textRef
  }), React.createElement(Cursor, {
    ref: cursorRef
  })));
};
const Container = styled.div(_templateObject());
const Line = styled.div(_templateObject2());
const Prompt = styled.span(_templateObject3());
const Cursor = styled.span(_templateObject4());